import React, { useState } from 'react'

import { Tabs, Tab } from 'components/Tabs'
import { useMediaQuery } from 'hooks/useMediaQuery'
import style from './style.module.css'

type Props = {
  content: { tab: string; content: React.ReactNode }[]
}

function TabbedContent({ content }: Props) {
  const [selected, setSelected] = useState(0)
  const isMobile = useMediaQuery(`(max-width: 768px)`)

  return isMobile ? (
    <>
      {content.map((c, index) => (
        <div className={style.mobileContent} key={index}>
          <div className={style.mobileContentTab}>{c.tab}</div>
          {c.content}
        </div>
      ))}
    </>
  ) : (
    <>
      <Tabs role='tablist' mb={6}>
        {content.map((c, index) => (
          <Tab
            key={index}
            as='button'
            isActive={index === selected}
            onClick={() => setSelected(index)}
          >
            {c.tab}
          </Tab>
        ))}
      </Tabs>
      <div className={style.content}>{content[selected].content}</div>
    </>
  )
}

export default TabbedContent
